import React, { useState } from 'react'
import {
  Button,
  Grid, TextField,
  Typography
} from '@mui/material'
// import MainCard from 'ui-component/cards/MainCard'
import PaymentTable from './Components/PaymentStatus/PaymentTable'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import SubCard from 'ui-component/cards/SubCard';
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
// import PaymentReport from 'views/utilities/Components/Pdf_Agreement/PaymentReport';
// import { PaymentReportapi } from 'API/Services';


const PaymentStatus = () => {
  const [Filter, setFilter] = useState({
    name: '',
    bank: '',
    mobile_number: '',
    mode_of_paymnet: '',
    payment_status: ''
  });
  // const [DataView,setDataView] = useState('')

  const handleChange = (name, value) => {
    console.log(name, value);

    if (name === 'name' && /^[A-Za-z]*$/.test(value)) {
      setFilter({ ...Filter, [name]: value });
    }
    else if (name === 'bank' && /^[A-Za-z]*$/.test(value)) {
      setFilter({ ...Filter, [name]: value });
    }
    else if (name === 'mobile_number' && /^\d*$/.test(value) && value.length <= 10) {
      setFilter({ ...Filter, [name]: value });
    }
    else if (name === 'mode_of_paymnet' && /^[a-z]+(_[a-z]+)*$/.test(value)) {
      if (value === 'select') {
        setFilter({ ...Filter, [name]: '' });
      }
      else {
        setFilter({ ...Filter, [name]: value });
      }
    }
    else if (name === 'payment_status' && /^[A-Za-z]*$/.test(value)) {
      if (value === 'select') {
        setFilter({ ...Filter, [name]: '' });
      }
      else {
        setFilter({ ...Filter, [name]: value });
      }
    }
  };
  const [searchFunction, setSearchFunction] = useState(null)
  const [clearFunction, setClearFunction] = useState(null)

  const handleClearFilter = () => {
    setFilter({
      name: '',
      bank: '',
      mobile_number: '',
      mode_of_paymnet: '',
      payment_status: ''
    })
    if (searchFunction) {
      clearFunction()
    }
  }


  const handleSearch = () => {
    if (searchFunction) {
      searchFunction()
    }
  }

  console.log(searchFunction);


  // useEffect(() => {
  //   PaymentReportapi(setDataView)
  // }, [])
  return (
    <Grid container>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <SubCard>
          {/* <Typography variant='h4' marginBottom={1} sx={{ color: "#20415C" }}>Payment Status</Typography> */}
          <Grid container spacing={2} alignItems='center'>
            <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Agent name</Typography>
              <TextField
                fullWidth
                value={Filter.name}
                onChange={(e) => handleChange('name', e.target.value)}
                size='small'
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }
                }
              />

            </Grid>
            <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Mobile Number</Typography>
              <TextField
                fullWidth
                value={Filter.mobile_number}
                onChange={(e) => handleChange('mobile_number', e.target.value)}
                size='small'
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }
                }
              />

            </Grid>
            {/* <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
              <TextField
                label="Bank name"
                fullWidth
                value={Filter.bank}
                onChange={(e)=>handleChange('bank',e.target.value)}
              />
            </Grid> */}

            <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Payment Type</Typography>
              <FormControl fullWidth size='small'>
                <Select
                  labelid="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Filter.mode_of_paymnet ? Filter.mode_of_paymnet : "select"}
                  onChange={(e) => handleChange('mode_of_paymnet', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                      borderRadius: '8px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                    },
                  }}
                >
                  <MenuItem value={'select'}>Select</MenuItem>
                  <MenuItem value={'full_payment'}>Full payment</MenuItem>
                  <MenuItem value={'part_payment'}>Part payment</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Payment Status</Typography>
              <FormControl fullWidth size='small'>
                <Select
                  labelid="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Filter.payment_status ? Filter.payment_status : "select"}
                  onChange={(e) => handleChange('payment_status', e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                      borderRadius: '8px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      border: '2px solid #A9A9A980 50%',
                    },
                  }}
                >
                  <MenuItem value={'select'}>Select</MenuItem>
                  <MenuItem value={'pending'}>Pending</MenuItem>
                  <MenuItem value={'successful'}>Successful</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xl={2} lg={2} md={2} xs={12} mt={3}>
              <Button
                variant='contained'
                color='secondary'
                fullWidth
                onClick={() => handleSearch()}
                sx={{
                  backgroundColor: "#688B2A",
                  color: "#FFFFFF",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#688B2A",
                  },
                }}
              >Search</Button>
            </Grid>

            <Grid item xl={2} lg={2} md={2} xs={12} mt={3}>
              <Button
                variant='outlined'
                color='secondary'
                fullWidth
                onClick={() => handleClearFilter()}
                sx={{
                  backgroundColor: "#592375",
                  color: "#FFFFFF",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#592375",
                  },
                }}

              >Clear</Button>
            </Grid>


          </Grid>
        </SubCard>

      </Grid>
      <Grid item xs={12} width='100%' >

        <MainCard sx={{ marginTop: '20px', width: '100%' }}>
          <PaymentTable filter={Filter} setSearchFunction={setSearchFunction} setClearFunction={setClearFunction} />
        </MainCard>
      </Grid>
    </Grid>
  )
}

export default PaymentStatus
